import type { JSX } from "react";

import { DeleteOutlined } from "@ant-design/icons";
import { Button } from "@impero-com/ui";
import { Select } from "antd";
import { DefaultOptionType } from "antd/es/select";

import * as theme from "../theme.css";

interface HeaderButtonsProps {
    onClickRemove: (index: number) => void;
    onChangeOrder: (index: number, newOrder: number) => void;
    index: number;
    siblingsLength: number;
    deleteDisabled?: boolean;
    changeOrderDisabled?: boolean;
}

export function HeaderButtons(props: HeaderButtonsProps): JSX.Element {
    return (
        <div className={theme.sectionHeader}>
            <Button
                icon={<DeleteOutlined />}
                disabled={props.deleteDisabled || props.siblingsLength <= 1}
                className={theme.headerButton}
                onClick={() => props.onClickRemove(props.index)}
            />
            <Select
                className={theme.headerButton}
                dropdownMatchSelectWidth={false}
                disabled={props.changeOrderDisabled}
                options={getOrderOptions(props.siblingsLength)}
                onChange={(value: number) => {
                    props.onChangeOrder(props.index, value);
                }}
                value={props.index}
            />
        </div>
    );
}

function getOrderOptions(sectionCount: number): Array<DefaultOptionType> {
    return Array.from({ length: sectionCount }, (_, i) => ({
        label: i + 1 + ".",
        value: i,
    }));
}
